export default function DnBidimu({ setCurrentPage }) {
  return (
    <div className='fixedMobileSize'>
      {/* <img src={'https://res.cloudinary.com/dw4o2gz3v/image/upload/q_auto:low/auruduBubble/2_bidimu_ev7zhi.png'} className={'welcome'} alt='welcomePage' /> */}
      <img src={'https://res.cloudinary.com/da0jtwj5x/image/upload/q_auto:low/v1774684936/aurudu2026/5-kanamuttiyabidimu_vxctet.jpg'} className={'welcome'} alt='welcomePage' />

      <a
        onClick={() => {
          setCurrentPage(4);
        }}
      >
        <img src={'https://res.cloudinary.com/experbot-com/image/upload/w_300/Aurudu/idiriyata_yanna_wp3uza.png'} className={'welcomeButton'} alt='button' />
      </a>
    </div>
  );
}
